export const AppErrorTypes = {
    GUIDE_HAS_TASKS: 'hasTasks',
};

export class AppError extends Error {
    constructor(type, message) {
        super(message);
        this.name = 'AppError';
        this.type = type;
    }
}
